export default __webpack_public_path__ + "static/media/zhgd.784a3db7.jpg";